import { AccountInfo } from '../modules/administration/models/account-info';

export class User {
  userName?: string;
  email: string;
  code?: string;
  password: string;
  confirmPassword:string;
  name?: string;
  firstName?: string;
  familyName?: string;
  fullName?: string;
  idAccount?:string;
  storageType?:string;  
}
export class UserDto{
  id: string;
  code?: string;
  userName?: string;
  email?: string;
  name?: string;
  firstName?: string;
  familyName?: string;
  fullName?: string;
  roles?: string[];
  storageType?: string;
  idAccount?: string;
  account?: AccountInfo;
}
export class UserAssignRoles{
  user:UserDto;
  roles:string[];
}
